import React from 'react';

export const FullscreenMessage = ({ message }) => {
  let title = message?.title;
  let details = message?.details;

  if (message?.title && !message?.details) {
    title = undefined;
    details = message.title;
  }

  return message?.type === 'error' ? (
    <div className="error-msg">
      <div className="error-title">{title}</div>
      <div className="error-details">{details}</div>
    </div>
  ) : null;
};
